export function isWithinAWeek(startDate, checkDate) {
    const weekFrom = new Date(startDate);
    weekFrom.setDate(startDate.getDate() + 7);

    return checkDate >= startDate && checkDate <= weekFrom;
}